<template>
  <a-modal
    :visible="visible"
    title="提示"
    @cancel="Close"
    @ok="handleOk"
  >
    <a-row style="padding: 8px">
      <a-col :span="2" style="margin-right: 8px">
        <a-icon type="close-circle" style="color: red; font-size: 22px" />
      </a-col>
      <a-col :span="20">
        <p class="info">现在退出将<span style="color: red">丢失已编辑的内容</span>，</p>
        <p>确定要退出吗？</p>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
export default {
  name: 'CloseMessage',
  components: {

  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    Close () {
      this.visible = false
      this.$emit('close')
    },
    handleOk () {
      this.visible = false
      this.$emit('ok', 'true')
    }
  }
}
</script>
<style scoped>

</style>
